import { Dispatch, SetStateAction } from "react";
import { useGetDivisionQuery } from "../../features/api";
import {
  ApplicationCompanyInfo,
  ApplicationStoreInfo,
  CSDict,
  Division,
} from "../../features/api-interfaces";
import { CompanyInfoRow } from "./CompanyInfoRow";
import Table from "./Table";
import { LABELS } from "./constants";
import { SpaceBetween, Tabs } from "@cloudscape-design/components-themed";
import { CompanyInfoHeader } from "./CompanyInfoHeader";

interface ApplicationInfoTabProps {
  officialCompany: ApplicationCompanyInfo | undefined;
  applicationCompany: ApplicationCompanyInfo | undefined;
  stores: ApplicationStoreInfo[];
  appStatusCodes: CSDict[];
  appDetailStatusCodes: CSDict[];
  isDocomoUser: boolean;
  isDocomoStaffUser: boolean;
  isDocomoMasterUser: boolean;
  isFetching?: boolean;
  hasDiffCompany: boolean;
  setIsModalOpen: Dispatch<SetStateAction<boolean>>;
}

/**
 * 申請内容照会 タブ表示
 */
export const Tab = (props: ApplicationInfoTabProps) => {
  const {
    officialCompany,
    applicationCompany,
    stores,
    appStatusCodes,
    appDetailStatusCodes,
    isDocomoUser,
    isDocomoStaffUser,
    isDocomoMasterUser,
    isFetching,
    hasDiffCompany,
    setIsModalOpen,
  } = props;
  const divisionData = useGetDivisionQuery("3");
  const serviceDivisions = divisionData?.data as Division[];

  const getBusinessForm = (soleFlag: boolean | undefined | null) => {
    if (soleFlag === undefined || soleFlag === null) {
      return "";
    } else {
      return soleFlag ? "個人" : "法人";
    }
  };
  const getServiceString = (value: string) => {
    if (serviceDivisions) {
      const result = serviceDivisions.find(
        (code) => code.kbnCode === value
      )?.label;
      return result;
    } else {
      return "";
    }
  };

  return (
    <Tabs
      tabs={[
        {
          label: LABELS.CORPORATE_INFORMATION,
          id: "first",
          content: (
            <SpaceBetween direction="vertical" size="xxxs">
              <CompanyInfoHeader
                hasDiffCompany={hasDiffCompany}
                setIsModalOpen={setIsModalOpen}
              />
              <CompanyInfoRow
                label={LABELS.COMPANY}
                official={officialCompany?.companyName}
                application={applicationCompany?.companyName}
              />
              <CompanyInfoRow
                label={LABELS.BUSINESS_FORM}
                official={
                  officialCompany
                    ? getBusinessForm(officialCompany.soleProprietorshipFlag)
                    : ""
                }
                application={
                  applicationCompany
                    ? getBusinessForm(applicationCompany.soleProprietorshipFlag)
                    : ""
                }
              />
              <CompanyInfoRow
                label={LABELS.CORPORATE_NUMBER}
                official={officialCompany?.corporateNumber}
                application={applicationCompany?.corporateNumber}
              />
              <CompanyInfoRow
                label={LABELS.REPRESENTATIVE}
                official={officialCompany?.repName}
                application={applicationCompany?.repName}
              />
              <CompanyInfoRow
                label={LABELS.MERCHANT_CATEGORY}
                official={officialCompany?.merchantType}
                application={applicationCompany?.merchantType}
              />
              <CompanyInfoRow
                label={LABELS.MERCHANT_NAME}
                official={officialCompany?.merchantName}
                application={applicationCompany?.merchantName}
              />
              <CompanyInfoRow
                label={LABELS.POST_CODE}
                official={officialCompany?.postalCode}
                application={applicationCompany?.postalCode}
              />
              <CompanyInfoRow
                label={LABELS.ADDRESS}
                official={officialCompany?.address}
                application={applicationCompany?.address}
              />
              <CompanyInfoRow
                label={LABELS.TEL}
                official={officialCompany?.phoneNumber}
                application={applicationCompany?.phoneNumber}
              />
              <CompanyInfoRow
                label={LABELS.SERVICE}
                official={
                  officialCompany
                    ? getServiceString(officialCompany.contractServiceCode)
                    : ""
                }
                application={
                  applicationCompany
                    ? getServiceString(applicationCompany.contractServiceCode)
                    : ""
                }
              />
              <CompanyInfoRow
                label={LABELS.QR_PRESENTATION}
                official={officialCompany?.qr}
                application={applicationCompany?.qr}
              />
              <CompanyInfoRow
                label={LABELS.TYPE_OF_CONTRACT}
                official={officialCompany?.contractStyle}
                application={applicationCompany?.contractStyle}
              />
              <CompanyInfoRow
                label={LABELS.CONTRACT_ROUTE}
                official={officialCompany?.contractRoute}
                application={applicationCompany?.contractRoute}
              />
              {isDocomoStaffUser && (
                <CompanyInfoRow
                  label={LABELS.COMMISSION_RATE}
                  official={officialCompany?.settlementFeeRate}
                  application={applicationCompany?.settlementFeeRate}
                />
              )}
              <CompanyInfoRow
                label={LABELS.CPID}
                official={officialCompany?.cpid}
                application={applicationCompany?.cpid}
              />
              {isDocomoUser && (
                <CompanyInfoRow
                  label={LABELS.PARTICULAR_RATE}
                  official={
                    officialCompany ? officialCompany.particularRateFlag : ""
                  }
                  application={
                    applicationCompany
                      ? applicationCompany.particularRateFlag
                      : ""
                  }
                />
              )}
            </SpaceBetween>
          ),
        },
        {
          label: LABELS.STORE_INFORMATION,
          id: "second",
          content: (
            <Table
              stores={stores}
              appStatusCodes={appStatusCodes}
              appDetailStatusCodes={appDetailStatusCodes}
              isDocomoUser={isDocomoUser}
              isDocomoMasterUser={isDocomoMasterUser}
              isFetching={isFetching}
            />
          ),
        },
      ]}
    />
  );
};
